<template>
  <div class="whs-detail-rooms">
    <FeedbackForm
      :room="currentRoom"
      v-show="feedbackFormIsOpen"
      :toggleFeedbackForm="toggleFeedbackForm"
    >
      <FeedbackRoom :room="currentRoom" />
    </FeedbackForm>

    <RoomFullscreen
      v-show="fullscreen"
      :room="currentRoom"
      :closeRoom="closeRoom"
      :toggleFeedbackForm="toggleFeedbackForm"
    />
    <div class="whs-detail-rooms-title">
      Доступные номера
      <span class="whs-detail-rooms-total">Всего: {{ roomGroups.length }}</span>
    </div>
    <div
      class="whs-detail-room-group"
      v-for="roomGroup in roomGroups"
      :key="roomGroup.room_group_id"
    >
      <div class="whs-detail-room">
        <div
          class="whs-detail-room-image-wrap"
          @click="toggleFullscreen(roomGroup.rooms[0].book_hash)"
        >
          <img
            class="whs-detail-room-image"
            v-if="roomGroup.info && roomGroup.info.thumbnail_tmpl"
            :src="getThumbnail(roomGroup.info.thumbnail_tmpl)"
            alt
          />
          <div
            v-if="roomGroup.info && roomGroup.info.image_list_tmpl.length > 0"
            class="whs-detail-room-image-show"
          >{{roomGroup.info.image_list_tmpl.length}} фото</div>
          <div v-else class="whs-detail-room-image-show">Фото отсутсвует</div>
        </div>
        <div
          v-if="roomGroup.info"
          class="whs-detail-room-main"
          @click="toggleFullscreen(roomGroup.rooms[0].book_hash)"
        >
          <div class="whs-detail-room-name">{{ roomGroup.info.name }}</div>
          <!-- <div class="whs-detail-room-subtitle">{{ roomGroup.info.name_struct.bedding_type }}</div> -->
          <div class="whs-detail-room-description">{{ roomGroup.info.description }}</div>
          <DetailIcons
            v-if="roomGroup.info && roomGroup.info.ota_room_amenity_data && roomGroup.info.ota_room_amenity_data.length > 0"
            :amenities="roomGroup.info.ota_room_amenity_data"
          />
        </div>

        <div class="whs-detail-room-next">
          <div class="whs-detail-room-footer">
            <div class="whs-small">Мин. цена за номер</div>
            <div
              class="whs-detail-room-price whs-price-small"
            >{{ toLocalePrice(calcPrice(roomGroup.rooms[0])) }}</div>
            <div
              class="whs-button-second"
              @click="toggleFullscreen(roomGroup.rooms[0].book_hash)"
            >Подробнее</div>
          </div>
        </div>
      </div>
      <div class="whs-detail-room-rates">
        <div
          class="whs-detail-room-rate"
          v-for="room in roomGroup.rooms"
          :key="room.book_hash"
          :class="{'is-best': room === rooms[0]}"
        >
          <div class="whs-rate-info">
            <div
              class="whs-list-info-line info-cancellation whs-icon-left"
              :class="{'has-cancellation': room.cancellation_info.free_cancellation_before}"
            >{{ getCancelationInfo(room) }}</div>
            <div
              class="whs-list-info-line whs-icon-left"
              :class="{'has-meal': room.meal !== 'nomeal'}"
            >{{ toLocaleMeal(room.meal) }}</div>
          </div>
          <div class="whs-rate-next">
            <div class="whs-rate-price">
              <div class="whs-small" v-if="room === rooms[0]">Лучшая цена в отеле</div>
              <div class="whs-detail-room-price">{{ toLocalePrice(calcPrice(room)) }}</div>
              <div class="whs-small">{{ nightsAdults }}</div>
              <div
                v-if="room.payment_options.payment_types[0].tax_data"
                class="whs-small"
                :class="{ 'has-tax': hasTax(room.payment_options.payment_types[0].tax_data) }"
              >{{ validateTax(room.payment_options.payment_types[0].tax_data) }}</div>
            </div>
            <div class="whs-rate-button-wrap">
              <div class="whs-button-main" @click="toggleFeedbackForm(room.book_hash)">Забронировать</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailIcons from '../components/HotelDetailIcons.vue';
import RoomFullscreen from '../components/HotelDetailRoomsFullscreen.vue';
import FeedbackForm from '../components/FeedbackForm.vue';
import FeedbackRoom from '../components/FeedbackRoom.vue';
import { mapState, mapGetters } from 'vuex';
import { calcPrice } from '@/api';

export default {
  name: 'RoomGroups',
  props: {
    roomGroups: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      fullscreen: false,
      feedbackFormIsOpen: false,
      currentRoom: null,
      ...mapState(['modal'])
    };
  },
  computed: {
    ...mapState('hero', ['nightsAdults', 'currencyText', 'officeList']),
    ...mapGetters(['context']),
    ...mapGetters('hero', ['toLocalePrice']),
    ...mapState('hotel', ['rooms'])
  },
  methods: {
    hasTax(tax_data) {
      if (!tax_data.taxes) {
        return;
      }
      return tax_data.taxes.some(t => !t.included_by_supplier);
    },
    validateTax(tax_data) {
      if (!tax_data.taxes) {
        return '';
      }
      const taxes = tax_data.taxes.filter(t => !t.included_by_supplier);
      if (taxes.length > 0) {
        return `+ налоги: ${taxes
          .reduce(
            (acc, tax) => `${acc} ${tax.amount} ${tax.currency_code},`,
            ''
          )
          .slice(0, -1)}`;
      }
      return 'Все налоги включены';
    },
    nameTitle(name) {
      return name.replace(/\(.*?\)/g, '').trim();
    },
    nameSubTitle(name) {
      const matched = name.match(/\((.*?)\)/g);
      if (matched.length > 0) return matched[0].slice(1, -1);
      return '';
    },
    getThumbnail(string) {
      return string.replace('{size}', 'x220');
    },
    // toLocalePrice(price) {
    //   return `${Math.ceil(price, 10).toLocaleString('ru-Ru')} ${
    //     this.currencyText
    //   }`;
    // },
    setCurrentRoom(book_hash) {
      const room = this.rooms.find(room => room.book_hash === book_hash);
      const info = this.roomGroups.find(
        roomGroup => roomGroup.room_group_id === room.room_group_id
      ).info;
      this.currentRoom = Object.assign({}, room, { info });
    },
    toggleFullscreen(book_hash) {
      this.setCurrentRoom(book_hash);
      this.fullscreen = true;
      this.$store.commit('setModal', true);
    },
    closeRoom() {
      this.fullscreen = false;
      this.currentRoom = null;
      this.$store.commit('setModal', false);
    },
    toggleFeedbackForm(book_hash) {
      if (
        this.officeList.length === 0 &&
        (this.context === 'main' || this.context === 'main-pm')
      ) {
        this.$store.dispatch('hero/getOfficeList');
      }

      if (this.fullscreen) this.fullscreen = false;
      if (book_hash === false) {
        this.feedbackFormIsOpen = false;
        this.$store.commit('setModal', false);
        return;
      }
      if (!book_hash && !this.currentRoom) return;
      if (book_hash) this.setCurrentRoom(book_hash);
      this.feedbackFormIsOpen = true;
      this.$store.commit('setModal', true);
    },
    toLocaleMeal(meal) {
      const i18n = {
        nomeal: 'Питание не включено',
        breakfast: 'Завтрак включен',
        'breakfast-buffet': 'Завтрак - Шведский стол',
        'continental-breakfast': 'Континентальный завтрак'
      };
      return i18n[meal] ? i18n[meal] : `Питание: ${meal}`;
    },
    getCancelationInfo(room) {
      if (!room.cancellation_info.free_cancellation_before)
        return `При отмене стоимость не возвращается`;

      const month = [
        'янв',
        'фев',
        'мар',
        'апр',
        'мая',
        'июня',
        'июля',
        'авг',
        'сен',
        'окт',
        'нояб',
        'дек'
      ];
      const date = new Date(room.cancellation_info.free_cancellation_before);
      return `Бесплатная отмена до ${date.getDate()} ${month[date.getMonth()]}`;
    },
    calcPrice
  },
  components: {
    DetailIcons,
    RoomFullscreen,
    FeedbackForm,
    FeedbackRoom
  }
};
</script>

<style scoped>
.whs-detail-rooms-title {
  text-align: center;
  font-size: 24px;
  padding: 18px;
}
.whs-detail-rooms-total {
  display: inline-flex;
  background-color: var(--color-bg-dark);
  padding: 0 8px;
  font-size: 16px;
  border-radius: 24px;
}
/* .whs-detail-rooms {
} */
.whs-detail-room-group {
  margin-bottom: 12px;
  border-radius: 4px;
  box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
  overflow: hidden;
}
.whs-detail-room {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  background-color: #fff;
  overflow: hidden;
}
@media (max-width: 575px) {
}
.whs-detail-room-image-wrap {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex: 2 0 130px;
  height: 220px;
  background-color: var(--color-bg-dark);
  position: relative;
  cursor: pointer;
}
.whs-detail-room-image-show {
  padding: 4px 8px;
  background-color: var(--color-bg);
  border-radius: 12px;
  margin-bottom: 12px;
  position: absolute;
  bottom: 0;
}
.whs-detail-room-image {
  width: 100%;
  height: 220px;
  object-fit: cover;
}
.whs-detail-room-main {
  max-height: 100%;
  padding: 8px 16px;
  flex: 3 0 270px;
  cursor: pointer;
  position: relative;
}
.whs-detail-room-main:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 12px;
  background: linear-gradient(#fff0, #fff 50%);
}
.whs-detail-room-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text);
  max-height: 38px;

  overflow: hidden;
}
.whs-detail-room-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-5);
  margin-bottom: 4px;
}
.whs-detail-room-description {
  font-size: 13px;
  color: var(--color-text-5);
  max-height: 74px;
  overflow: hidden;
}
.whs-detail-room-next {
  padding: 8px 18px;
  flex: 1 0 130px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
}
.whs-detail-room-price {
  font-size: 22px;
  font-weight: 700;
}
.whs-price-small {
  font-size: 18px;
}
/* .whs-detail-room-footer {
} */

.whs-list-info-line {
  margin-top: 2px;
  padding: 2px 4px;
  display: inline-flex;
}
.whs-list-info-line.has-meal {
  color: var(--color-third);
  font-weight: 500;
}
.whs-list-info-line.has-cancellation {
  color: var(--color-text-cold);
  font-weight: 500;
}

.whs-list-info-line:before {
  margin-right: 12px;
  align-self: center;
  text-align: center;
  color: var(--color-text-5);
  content: '\f2e7';
}
.whs-list-info-line.info-cancellation:before {
  content: '\f05e';
}
.whs-list-info-line.has-meal:before {
  content: '\f725';
  color: var(--color-third);
}
.whs-list-info-line.has-cancellation:before {
  content: '\f00c';
  color: var(--color-text-cold);
}
/*
.whs-detail-room-rates {
} */
.whs-detail-room-rate {
  background-color: #fff;
  border-top: 1px solid var(--color-bg-dark);
  display: flex;
  flex-wrap: wrap;
  padding: 12px 0;
}
.whs-detail-room-rate.is-best {
  border-left: 4px solid var(--color-bg-cold);
  padding-left: 0;
  background-color: var(--color-bg-cold-5);
}
.whs-rate-info {
  max-width: 100%;
  display: flex;
  padding: 8px 18px;
  flex: 4 0 400px;
  flex-direction: column;
  align-items: flex-start;
}
.whs-rate-next {
  flex: 3 0 300px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 8px 18px;
  justify-content: flex-end;
}
.whs-rate-price {
  padding-right: 18px;
}
/* .whs-rate-button-wrap {
} */
.has-tax {
  font-weight: 500;
  color: var(--color-second);
}
</style>